import { FILE_TYPE } from './file-types';

export class FileClass {
  file: File;
  name: string; // name of the file
  size: number; // size of the file
  type: string; // type of the file

  constructor(file: File) {
    this.file = file;
    this.name = file.name;
    this.size = file.size;
    this.type = file.type || '';
  }

  async classify() {
    const type = this.getNormalType();

    if (this.isImageFile(type)) {
      return 'image';
    } else if (this.isVideoFile(type)) {
      return 'video';
    } else if (this.isDocumentFile(type) && this.type !== 'html') {
      return 'document';
    } else if (this.isArchive(type)) {
      return 'archive';
    } else if (this.isAudioFile(type)) {
      return 'audio';
    } else if (await this.isDicomFile()) {
      return 'dicom';
    }

    return null;
  }

  getNormalType() {
    if (!this.type) {
      return null;
    }

    if (this.type.includes('/')) {
      const split = this.type.split('/')[1];
      return split;
    } else {
      return this.type;
    }
  }

  async isDicomFile() {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(this.file);

      reader.onload = (evt: any) => {
        if (evt.target.readyState === FileReader.DONE) {
          const array = new Uint8Array(evt.target.result);
          let s = '';
          const start = 128,
            end = 132;
          for (let i = start; i < end; ++i) {
            s += String.fromCharCode(array[i]);
          }

          if (s === 'DICM') {
            resolve(true);
          } else {
            resolve(false);
          }
        }
      };
    });
  }

  fileSize(bytes: any, decimals = 0) {
    if (bytes === 0) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  isVideoFile(_type: any) {
    if (!_type) {
      return false;
    }
    const type = _type.toString().toLowerCase().valueOf();
    return FILE_TYPE.VIDEO.indexOf(type) !== -1;
  }

  isArchive(_type: any) {
    if (!_type) {
      return false;
    }
    const type = _type.toString().toLowerCase().valueOf();
    return FILE_TYPE.ARCHIVE.indexOf(type) !== -1;
  }

  isImageFile(_type: any) {
    if (!_type) {
      return false;
    }
    const type = _type.toString().toLowerCase().valueOf();
    return FILE_TYPE.IMAGE.indexOf(type) !== -1;
  }

  isDocumentFile(_type: any) {
    if (!_type) {
      return false;
    }
    const type = _type.toString().toLowerCase().valueOf();
    return FILE_TYPE.DOCUMENT.indexOf(type) !== -1;
  }

  isAudioFile(_type: any) {
    if (!_type) {
      return false;
    }
    const type = _type.toString().toLowerCase().valueOf();
    return FILE_TYPE.AUDIO.indexOf(type) !== -1;
  }
}
